export const OPTHINES = {
  voteName: '2020project/2020pneumonia',
  mustSearch: 'Button',
  buttonBg: '#f4a842',
  number: {
    mustRank: true,
  },
  name: true,
  content: true,
  user: true,
  checkBox: false,
  themeColor: {
    activeBgColor: 'rgb(255,241,142)',
    inactiveBgColor: '#f80000',
  },
  tabs: [
    {
      tabName: '新春留言墙',
      tabPath: '/20200120NHHD/1',
    },
    {
      tabName: '节目评选',
      tabPath: '/20200120NHHD/2',
    },
    {
      tabName: '演员评选',
      tabPath: '/20200120NHHD/3',
    },
    {
      tabName: '活动规则',
      tabPath: '/20200120NHHD/4',
    },
  ],
};
